import FetchUtils from 'src/utils/fetch_utils';
import LayoutUtils from 'src/utils/layout_utils';

/**
 * Init inline notes editor: click display to edit, save on blur, Escape to cancel.
 */
export function initNotesEditor(noteWrap) {
  if (noteWrap.dataset.bound === 'true') {
    return;
  }

  const display = noteWrap.querySelector('.js-showing-view-note-display');
  const input = noteWrap.querySelector('.js-showing-view-note-input');
  const placeholder = noteWrap.dataset.placeholder || 'No notes yet.';
  const saveUrl = noteWrap.dataset.saveNotesUrl;

  if (!display || !input || !saveUrl) {
    return;
  }

  const stopEditing = () => {
    noteWrap.classList.remove('showing-view-popup__note--editing');
    LayoutUtils.show(display);
    LayoutUtils.hide(input);
  };

  const startEditing = () => {
    noteWrap.classList.add('showing-view-popup__note--editing');
    LayoutUtils.hide(display);
    LayoutUtils.show(input);
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  };

  const updateDisplay = (value) => {
    const normalizedValue = value || '';
    const text = normalizedValue.trim().length ? normalizedValue : placeholder;
    display.textContent = text;
    input.value = normalizedValue;
    noteWrap.dataset.value = normalizedValue;
  };

  const save = () => {
    const currentValue = input.value;
    const oldValue = noteWrap.dataset.value || '';
    stopEditing();

    if (currentValue === oldValue) {
      return;
    }

    updateDisplay(currentValue);

    const body = new URLSearchParams();
    body.set('showing[notes]', currentValue);

    fetch(saveUrl, {
      method: 'PUT',
      headers: {
        'x-csrf-token': FetchUtils.CSRFToken(),
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'text/javascript'
      },
      body: body.toString()
    })
      .then(FetchUtils.checkResponseStatus)
      .catch((err) => {
        updateDisplay(oldValue);
        FetchUtils.handleResponseError(err);
      });
  };

  noteWrap.dataset.value = input.value || '';
  display.addEventListener('click', () => startEditing());
  display.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      startEditing();
    }
  });

  input.addEventListener('blur', () => save());
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      input.value = noteWrap.dataset.value || '';
      stopEditing();
    }
  });

  noteWrap.dataset.bound = 'true';
}
